// Unique counter per COMPONENT that uniqueness is added to
let _globallyUniqueIdCounter = 0

function resetUniqueIds() {
  _globallyUniqueIdCounter = 0
}

function injectUniqueness(component) {
  // Store all state in the closure f or the member functions
  const willUpdate = component.UNSAFE_componentWillUpdate,
    _htmlIds = {},
    _uniqueInstance = ++_globallyUniqueIdCounter

  let _uniqueIdCounter = 0

  // Inject the following functions into the component
  component.UNSAFE_componentWillUpdate = function(nextProps, nextState) {
    _uniqueIdCounter = 0
    if (typeof willUpdate != 'undefined') {
      willUpdate.apply(component, nextProps, nextState)
    }
  }

  component.nextUniqueId = function() {
    _uniqueIdCounter++

    return `id-${_uniqueInstance}-${_uniqueIdCounter}`
  }

  component.lastUniqueId = function() {
    return `id-${_uniqueInstance}-${_uniqueIdCounter}`
  }

  component.getUniqueId = function(identifier) {
    if (typeof identifier !== 'string') {
      console.log('Warning: Expected string identifer passed to `getUniqueId`')
      identifier = `${identifier}`
    }

    if (!_htmlIds[identifier]) {
      _htmlIds[identifier] = `id-${_uniqueInstance}-${identifier}`
    }

    return _htmlIds[identifier]
  }
}

module.exports = {
  resetUniqueIds,
  enableUniqueIds: injectUniqueness
}
